import React, { Component } from 'react';
import FlatButton from 'material-ui/FlatButton';
import { AccentColor } from 'helpers/AccentColorHelper';

class HeaderWithPeriod extends Component {
  renderStyle = () => {
    if (this.props.newStyle) {
      return { margin: '7px 0 0' };
    }

    return { marginBottom: '5px' };
  };
  render() {
    return (
      <div style={this.renderStyle()}>
        <span className="page-title">{this.props.headerText}</span>
        <span
          style={{
            color: AccentColor(),
            fontFamily: 'Circular-Black',
            fontSize: '25px',
          }}
        >
          .
        </span>
        {this._renderActionButton()}
      </div>
    );
  }

  _renderActionButton = () => {
    if (!this.props.actionButtonLabel) return null;

    return (
      <FlatButton
        label={this.props.actionButtonLabel}
        type="submit"
        primary
        backgroundColor={AccentColor()}
        hoverColor="grey"
        onClick={this.props.toggleDialog}
        style={{
          color: 'white',
          float: 'right',
          height: '30px',
          fontSize: '13px',
          lineHeight: '30px',
          marginTop: '3px',
        }}
      />
    );
  };
}

export default HeaderWithPeriod;
